import { render, staticRenderFns } from "./learningDetails.vue?vue&type=template&id=0def636c&scoped=true"
import script from "./learningDetails.vue?vue&type=script&lang=js"
export * from "./learningDetails.vue?vue&type=script&lang=js"
import style0 from "./learningDetails.vue?vue&type=style&index=0&id=0def636c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0def636c",
  null
  
)

export default component.exports